export const CASE_STUDIES_ROUTES = {
  INDEX: '/case-studies',
  CREATE: '/case-studies/create',
  VIEW: '/case-studies/$id',
  EDIT: '/case-studies/$id/edit',
} as const
